import { Alert, Typography } from "antd";
import CustomTabs from "../../components/CustomTabs/CustomTabs";
import DepositForm from "./components/DepositForm";
import ManualDisburseForm from "./components/ManualDisburseForm";
import PayoutTab from "./components/PayoutTab";
import { SHOW_MARK_AS_DUPLICATE } from "../../constants/manualDuplicate";
import "./BankOperations.scss";

const { Title } = Typography;

const BankOperations = () => {

  const tabItems = [
    { key: "disburse", label: "Disbursement", children: <ManualDisburseForm /> },
    { key: "deposit", label: "Record deposit", children: <DepositForm /> },
    { key: "settlement", label: "Payout", children: <PayoutTab /> },
  ];

  return (
    <div className="bank-operations-page">
      <Title level={4}>Bank Operations</Title>

      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Record bank transactions manually"
        description={
          SHOW_MARK_AS_DUPLICATE
            ? "Use these forms to record a disbursement, deposit, or payout. Tick Mark as duplicate when the same money was already posted."
            : "Use these forms to record a disbursement, deposit, or payout."
        }
      />

      <CustomTabs items={tabItems} defaultActiveKey="disburse" destroyInactiveTabPane />
    </div>
  );
};

export default BankOperations;
